<template>
    <div class="contact">
        <div class="contact_box">
            <!-- 背景图：添加动画类 -->
            <img v-if="isMobile==0" class="contact_bg animate-fade-in" src="../assets/contactbg.png">
            <img v-if="isMobile==1" class="contact_bg animate-fade-in" src="../assets/contat.png">

            <!-- 核心交互盒子：添加动画类 -->
            <div :class="isMobile==0?'':'contact_small_box_mobile'"
            class="contact_small_box animate-fade-in" @mouseenter="startSlideTimer" @mouseleave="stopSlideTimer"
                @click="handleGoBrandStory">
                <div :class="isMobile==0?'':'contact-sb-wrap_mobile'" class="contact-sb-wrap">
                    <div class="contact_sb_top contact-sb-top--upper" ref="slideRef">
                        <div :class="isMobile==0?'':'contact_sb_top_left_mobile'" class="contact_sb_top_left" v-if="lang.fyType == 2">Contact Us</div>
                        <div :class="isMobile==0?'':'contact_sb_top_left_mobile'" class="contact_sb_top_left" v-else>联系我们</div>
                        <img :class="isMobile==0?'':'contact_sb_top_right_mobile'"  class="contact_sb_top_right" src="../assets/whiteright.png" />
                    </div>
                </div>
                <div :class="isMobile==0?'':'contact_sb_top_mobile'" class="contact_sb_top contact-sb-top--lower">
                    <img  :class="isMobile==0?'':'cot_img_mobile'" class="cot_img" style="" src="../assets/email.png" />
                    <div :class="isMobile==0?'':'contact_sb_top_left_email_mobile'" class="contact_sb_top_left_email">choisivip@163 com</div>
                </div>
            </div>
        </div>
        <bottom-text :if-show="true"></bottom-text>
    </div>
</template>

<script>
// 脚本部分保持不变
import router from '@/router';
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'BrandStory',
    data() {
        return {
            lang: { fyType: 2 },
            slideTimer: null,
            isAnimating: false,
            isMobile: 0
        }
    },
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.isMobile = localStorage.getItem('isMobile')
        try {
            const langStr = localStorage.getItem('Lang')
            this.lang = langStr ? JSON.parse(langStr) : { fyType: 2 }
        } catch (e) {
            this.lang = { fyType: 2 }
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });
        console.log('Vue Router实例：', router);
        const slideEl = this.$refs.slideRef;
        if (slideEl) {
            slideEl.addEventListener('animationend', () => {
                this.isAnimating = false;
                slideEl.classList.remove('slide-active');
            });
        }
    },
    beforeUnmount() {
        this.stopSlideTimer();
        const slideEl = this.$refs.slideRef;
        if (slideEl) {
            slideEl.removeEventListener('animationend', () => { });
        }
    },
    methods: {
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
        },
        handleGoBrandStory() {
            try {
                router.push('/form-submit');
                console.log('路由跳转成功，目标路径：/form-submit');
            } catch (error) {
                console.error('路由跳转失败：', error);
            }
        },
        startSlideTimer() {
            if (this.slideTimer) return;
            this.triggerSlide();
            this.slideTimer = setInterval(() => {
                this.triggerSlide();
            }, 4000);
        },
        stopSlideTimer() {
            if (this.slideTimer) {
                clearInterval(this.slideTimer);
                this.slideTimer = null;
            }
            const slideEl = this.$refs.slideRef;
            if (slideEl) {
                slideEl.classList.remove('slide-active');
                this.isAnimating = false;
            }
        },
        triggerSlide() {
            const slideEl = this.$refs.slideRef;
            if (!slideEl || this.isAnimating) return;
            this.isAnimating = true;
            slideEl.classList.add('slide-active');
        }
    }
}
</script>

<style>
/* 原有样式保持不变 */
.contact {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
}

.contact_box {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    flex: 1;
    min-height: 400px;
    overflow: hidden;
}

.contact_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: filter 0.5s ease;
}

.contact_small_box:hover~.contact_bg {
    filter: blur(4px);
}

.contact_small_box {
    box-sizing: border-box;
    position: absolute;
    top: 43%;
    left: 41%;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    cursor: pointer;
}
.contact_small_box_mobile{
    align-items: flex-start;
    top: 43%;
    left: 20%;
    transform:translate(-50%, -50%);
}
.contact-sb-wrap {
    position: relative;
    overflow: hidden;
    width: 340px;
}
.contact-sb-wrap_mobile{
    height: 70px;
    margin-left: 20px;
}
.contact_sb_top {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    transition: all 0.5s ease;
}
.contact_sb_top_mobile{
    margin-left: 30px;
}
.contact-sb-top--upper {
    position: relative;
    white-space: nowrap;
    transform: translateX(0);
}

.contact-sb-top--upper.slide-active {
    animation: trainSlide 2s linear forwards;
}

@keyframes trainSlide {
    0% {
        transform: translateX(0);
        opacity: 1;
    }

    50% {
        transform: translateX(100%);
        opacity: 0;
    }

    50.1% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.contact-sb-top--lower {
    transform: translateY(0);
}

.cot_img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
.cot_img_mobile{
    width: 15px;
    height: 15px;
    margin-right: 5px;
}
.contact_sb_top_right_mobile{
    width: 5px;
    height: 5px;
}
.contact_small_box:hover .contact-sb-top--lower {
    transform: translateY(-5px) scale(1.05);
    z-index: 20;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.contact_sb_top_left {
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 52px;
    color: #FFFFFF;
    line-height: 52px;
    margin-right: 20px;
}
.contact_sb_top_left_mobile{
    font-size: 30px;
}
.contact_sb_top_right {
    width: 36px;
    height: 36px;
}

.contact_sb_top_left_email {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
}
.contact_sb_top_left_email_mobile{

    font-size: 14px;
}
/* 添加浮现动画相关样式 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    opacity: 0;
    animation: fadeIn 0.8s ease-out forwards;
}

/* 分层延迟：背景图先浮现，再显示核心盒子 */
.contact_bg {
    animation-delay: 0s;
}

.contact_small_box {
    animation-delay: 0.3s;
}
</style>